import { defineCustomElement, getAttribute, getBooleanAttribute, unpackCsv, getFirstCsvValue, getIntegerAttribute, getReactEventHandler, NectaryElement, updateAttribute, updateBooleanAttribute, updateCsv, updateIntegerAttribute, isAttrTrue, isAttrEqual } from '../utils';
const templateHTML = '<style>:host{display:block;outline:0;--sinch-grid-num-columns:1}#wrapper{display:grid;grid-template-columns:repeat(var(--sinch-grid-num-columns),auto);gap:16px;width:fit-content}:host([small]) #wrapper{gap:8px}:host([cols="2"]){--sinch-grid-num-columns:2}:host([cols="3"]){--sinch-grid-num-columns:3}:host([cols="4"]){--sinch-grid-num-columns:4}:host([cols="5"]){--sinch-grid-num-columns:5}:host([cols="6"]){--sinch-grid-num-columns:6}:host([cols="7"]){--sinch-grid-num-columns:7}:host([cols="8"]){--sinch-grid-num-columns:8}:host([cols="9"]){--sinch-grid-num-columns:9}:host([cols="10"]){--sinch-grid-num-columns:10}</style><div id="wrapper"><slot></slot></div>';
const template = document.createElement('template');
template.innerHTML = templateHTML;
defineCustomElement('sinch-tile-control', class extends NectaryElement {
  #$slot;
  constructor() {
    super();
    const shadowRoot = this.attachShadow();
    shadowRoot.appendChild(template.content.cloneNode(true));
    this.#$slot = shadowRoot.querySelector('slot');
  }
  connectedCallback() {
    this.setAttribute('role', 'tablist');
    this.#$slot.addEventListener('option-change', this.#onOptionChange);
    this.#$slot.addEventListener('slotchange', this.#onSlotChange);
    this.addEventListener('-change', this.#onChangeReactHandler);
  }
  disconnectedCallback() {
    this.#$slot.removeEventListener('option-change', this.#onOptionChange);
    this.#$slot.removeEventListener('slotchange', this.#onSlotChange);
    this.removeEventListener('-change', this.#onChangeReactHandler);
  }
  static get observedAttributes() {
    return ['value', 'small', 'multiple'];
  }
  attributeChangedCallback(name, oldVal, newVal) {
    if (isAttrEqual(oldVal, newVal)) {
      return;
    }
    switch (name) {
      case 'value':
        {
          this.#onValueChange(newVal ?? '');
          break;
        }
      case 'small':
        {
          this.#onSmallChange();
          updateBooleanAttribute(this, name, isAttrTrue(newVal));
          break;
        }
      case 'multiple':
        {
          this.#onValueChange(this.value);
        }
    }
  }
  set value(value) {
    updateAttribute(this, 'value', value);
  }
  get value() {
    return getAttribute(this, 'value', '');
  }
  set small(isSmall) {
    updateBooleanAttribute(this, 'small', isSmall);
  }
  get small() {
    return getBooleanAttribute(this, 'small');
  }
  set multiple(isMultiple) {
    updateBooleanAttribute(this, 'multiple', isMultiple);
  }
  get multiple() {
    return getBooleanAttribute(this, 'multiple');
  }
  set cols(value) {
    updateIntegerAttribute(this, 'cols', value);
  }
  get cols() {
    return getIntegerAttribute(this, 'cols', 1);
  }
  #onSlotChange = () => {
    this.#onValueChange(this.value);
    this.#onSmallChange();
  };
  #onOptionChange = e => {
    e.stopPropagation();
    const $elem = e.target;
    const value = e.detail;
    const detail = this.multiple ? updateCsv(this.value, value, !getBooleanAttribute($elem, 'data-checked')) : value;
    this.dispatchEvent(new CustomEvent('-change', {
      detail
    }));
  };
  #onValueChange(csv) {
    if (this.multiple) {
      const values = unpackCsv(csv);
      for (const $option of this.#$slot.assignedElements()) {
        const isChecked = !getBooleanAttribute($option, 'disabled') && values.includes(getAttribute($option, 'value', ''));
        updateBooleanAttribute($option, 'data-checked', isChecked);
      }
    } else {
      const value = getFirstCsvValue(csv);
      for (const $option of this.#$slot.assignedElements()) {
        const isChecked = !getBooleanAttribute($option, 'disabled') && value === getAttribute($option, 'value', '');
        updateBooleanAttribute($option, 'data-checked', isChecked);
      }
    }
  }
  #onSmallChange() {
    const isSmall = this.small;
    for (const $opt of this.#$slot.assignedElements()) {
      updateBooleanAttribute($opt, 'data-small', isSmall);
    }
  }
  #onChangeReactHandler = e => {
    getReactEventHandler(this, 'on-change')?.(e);
  };
});